import { CartLinesUpdateEvent } from '@shopify/events';
  if (!window.__iyUpsell) {
    window.__iyUpsell = true;
    document.addEventListener('click', async (event) => {
      const button = event.target.closest('[data-iy-upsell]');
      if (!button) return;
      button.disabled = true;
      const id = Number(button.dataset.iyUpsell);
      const deferred = CartLinesUpdateEvent.createPromise();
      button.dispatchEvent(new CartLinesUpdateEvent({ action: 'add', context: 'product', lines: [{ merchandiseId: String(id), quantity: 1 }], promise: deferred.promise }));
      try {
        const sections = [...document.querySelectorAll('cart-items-component')].map((el) => el.dataset.sectionId).filter(Boolean).join(',');
        const added = await fetch(Theme.routes.cart_add_url, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [{ id, quantity: 1 }], sections }),
        }).then((r) => r.json());
        const cart = await fetch(`${Theme.routes.cart_url}.js`).then((r) => r.json());
        deferred.resolve({
          cart: CartLinesUpdateEvent.createCartFromAjaxResponse(cart),
          detail: { items: cart.items, source: 'iyashi-upsell', sourceId: 'iyashi-upsell', itemCount: 1, sections: added.sections, didError: !!added.status },
        });
      } catch (error) {
        deferred.reject(error);
        button.disabled = false;
      }
    });
  }
